<div class="flex h-full">
  <sidebar
    class="sidebar overflow-y-auto border-0 border-r border-solid border-default"
    persistKey="dashboard"
    [(opened)]="panelOpen"
    [position]="'start'"
    [allowMultipleOpen]="true"
    [noShadow]="true"
  >
    <my-dashboard-sidebar />
  </sidebar>
  <div class="flex h-full min-h-0 flex-1 flex-col overflow-y-auto">
    <ng-container [ngTemplateOutlet]="dashboardContent" />
  </div>
</div>

<ng-template #dashboardContent>
  <div
    class="flex size-full flex-col gap-5 overflow-x-hidden bg-surface px-8 pt-16 pb-4 md:px-24 lg:px-16 xl:px-12 2xl:px-24"
  >
    <div class="flex flex-1 flex-col gap-8">
      @if (hasChecklistWidget()) {
        <div class="flex w-full justify-center">
          <my-checklist-widget
            class="w-full max-w-screen-lg"
            [items]="checklistItems()"
            [showFooter]="checklist().showFooter"
            [title]="checklistTitle()"
            [progress]="checklistProgress()"
            (dismissed)="dismissChecklist()"
          />
        </div>
      } @else {
        <div class="flex w-full gap-lg empty:hidden">
          <h2 class="m-0.5 text-2xl font-bold text-default" data-hj-suppress>
            {{ employeeGreetMessage | translate }} {{ authUser()?.first_name }}! 👋
          </h2>
        </div>
      }

      @if (!visibleWidgetCount()) {
        <div class="flex flex-1 flex-col items-center gap-4" [class.justify-center]="!hasChecklistWidget()">
          <sb-empty-state
            [title]="'Customise your dashboard' | translate"
            [description]="'Choose the widgets you want to see and make this space work for you.' | translate"
            icon="classify-add-2-regular"
          />

          <button
            sb-button
            [color]="'transparent'"
            [class.toggle-button--active]="panelOpen()"
            (click)="toggleSideBar()"
          >
            {{ 'Customise dashboard' | translate }}
          </button>
        </div>
      } @else {
        <div [class]="widgetGridClasses()">
          @if (dashboardFilters[dashboardFilterType.NEW_HIRES]?.visibility) {
            <new-hires-widget />
          }
          @if (dashboardFilters[dashboardFilterType.CONTRACT_RENEWALS]?.visibility) {
            <contract-renewals-widget />
          }
          @if (dashboardFilters[dashboardFilterType.FILES_TO_REVIEW]?.visibility) {
            <files-to-review-widget />
          }
          @if (dashboardFilters[dashboardFilterType.MY_SCHEDULE]?.visibility) {
            <my-schedule-widget />
          }

          @if (dashboardFilters[dashboardFilterType.MY_TIMESHEETS]?.visibility) {
            <my-timesheet-widget />
          }

          @if (dashboardFilters[dashboardFilterType.MY_OPEN_SHIFTS]?.visibility) {
            <my-open-shift-widget />
          }

          @if (dashboardFilters[dashboardFilterType.MY_EXCHANGES]?.visibility) {
            <my-exchange-widget />
          }

          @if (dashboardFilters[dashboardFilterType.MY_NEWS_ITEMS]?.visibility) {
            <my-news-items-widget />
          }

          @if (dashboardFilters[dashboardFilterType.BIRTHDAYS]?.visibility) {
            <upcoming-birthdays-widget />
          }

          @if (dashboardFilters[dashboardFilterType.WEATHER_FORECASTS]?.visibility) {
            <my-weather-forecast-widget />
          }

          @if (dashboardFilters[dashboardFilterType.ENDING_CONTRACTS]?.visibility) {
            <ending-contracts-widget />
          }

          @for (config of turnOverGraphConfigs; track config.filterType) {
            @if (dashboardFilters[config.filterType]?.visibility) {
              <app-turnover-graph
                [graphType]="config.graphType"
                [graphData]="graphData"
                [isLoading]="isLoading"
                [size]="turnOverGraphSize"
              />
            }
          }

          @if (dashboardFilters[dashboardFilterType.WORKED_VS_SCHEDULED_HOURS]?.visibility) {
            <app-worked-hours-graph [chartPayload]="chartPayload" [size]="turnOverGraphSize" />
          }
        </div>
      }
    </div>
    <div class="flex flex-wrap gap-sm self-start">
      @if (visibleWidgetCount()) {
        <button sb-button [color]="'transparent'" [class.toggle-button--active]="panelOpen()" (click)="toggleSideBar()">
          <sb-icon name="settings-6-regular" />
          {{ 'Customise dashboard' | translate }}
        </button>
      }
      <button sb-button [color]="'transparent'" (click)="openDashboardFeedbackSurvey()">
        <sb-icon name="look-up-regular" />
        {{ 'How does this dashboard feel?' | translate }}
      </button>
    </div>
  </div>
</ng-template>
